import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Box, Button, Center, Heading, Spinner, Stack, VStack, chakra, BoxProps, StackProps, Dialog } from '@chakra-ui/react';
import { CouponForm } from '@src/components/sco/Account/SignupPaywall/CouponForm';
import { PaywallProductCard, PaywallProductCardProps } from '@src/components/sco/Account/SignupPaywall/PaywallProductCard';
import { PaywallTermSelector } from '@src/components/sco/Account/SignupPaywall/PaywallTermSelector';
import { ButtonLink } from '@src/components/sco/ButtonLink.tsx';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { SSRGate } from '@src/components/sco/utilities/SSRGate';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { useQueryStateSet } from '@src/hooks/useQueryStateSet';
import { TrackEvent } from '@src/lib/TrackEvent';
import { gql } from '@src/lib/gql';
import { parseAsString } from 'nuqs';
import React, { ReactNode, useMemo, useState } from 'react';
import { useCookie } from 'react-use';
type SignupPaywallProps = {
  containerProps?: BoxProps;
  stackProps?: StackProps;
  productIds?: Array<string>;
  productAndTermIds?: Array<Array<string>>;
  productCardProps?: Partial<PaywallProductCardProps>;
  productCardPropsByProductAndTermId?: Record<string, Partial<PaywallProductCardProps>>;
  paywallOptions?: {
    couponCode?: string;
    termId?: string;
  };
  hideFreeOption?: boolean;
  hideTermSelector?: boolean;
  hideTitle?: boolean;
  hideOptionBar?: boolean;
  hideCouponCode?: boolean;
  onProductSelect?: PaywallProductCardProps['onSelect'];
  paddingY?: BoxProps['paddingY'];
  termIds?: string[];
  title?: ReactNode;
};
export const SignupPaywall = props => {
  const $ = _c(79);
  const {
    currentUser
  } = useCurrentUser();
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const [showSalesModal, setShowSalesModal] = useState(false);
  const [promoCookieValue] = useCookie("sco_promo");
  let t0;
  if ($[0] !== props.paywallOptions?.termId) {
    t0 = parseAsString.withDefault(props.paywallOptions?.termId || "month");
    $[0] = props.paywallOptions?.termId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== promoCookieValue || $[3] !== props.paywallOptions?.couponCode) {
    t1 = parseAsString.withDefault(props.paywallOptions?.couponCode || (promoCookieValue ? `${promoCookieValue}` : null));
    $[2] = promoCookieValue;
    $[3] = props.paywallOptions?.couponCode;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0 || $[6] !== t1) {
    t2 = {
      termId: t0,
      couponCode: t1
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const [paywallOptions, paywallOptionsValues] = useQueryStateSet(t2);
  useState(true);
  currentUser?.defaultCouponCode;
  const appliedCouponCode = paywallOptionsValues.couponCode ?? promoCookieValue;
  const termIds = props.termIds || [paywallOptionsValues.termId];
  let productAndTermIds = [];
  if (props.productAndTermIds) {
    productAndTermIds = props.productAndTermIds.map(_temp);
  } else {
    if (props.productIds) {
      props.productIds.forEach(productId_0 => {
        termIds.forEach(termId_0 => {
          productAndTermIds.push({
            productId: productId_0,
            termId: termId_0
          });
        });
      });
    }
  }
  const queryVariables = {
    productAndTermIds: props.productAndTermIds,
    productIds: props.productIds,
    couponCode: appliedCouponCode,
    termIds
  };
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = gql`
      query (
        $productAndTermIds: [[String]]
        $productIds: [String]
        $termId: String
        $termIds: [String]
        $couponCode: String
      ) {
        scoProducts(
          productAndTermIds: $productAndTermIds
          productIds: $productIds
          termId: $termId
          termIds: $termIds
          couponCode: $couponCode
        ) {
          id
          productId
          effectiveTermId
          appliedCoupon {
            code
          }
          effectiveTerm {
            abbreviation
            frequencyLabel
            everyMonthLabel
            name
            termId
          }
          effectivePricingInCents {
            nextAssessmentAt
            prepaidPeriodRequiresCard
            prepaidPeriods
            prepaidPeriodsUnit
            recurring
            signup
            trialDays
            trialRequiresCard
          }
          pricingInCents {
            prepaidPeriodRequiresCard
            prepaidPeriods
            prepaidPeriodsUnit
            recurring
            signup
            trialDays
            trialRequiresCard
          }
          terms {
            termId
            abbreviation
            frequencyLabel
            everyMonthLabel
            name
            termId
          }
          paywallOptions {
            title
            description
            features {
              slug
              title
              description
            }
          }
          title
        }
      }
    `;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const query = useQuery(t3, {
    variables: queryVariables,
    fetchPolicy: "network-only",
    ssr: false
  });
  let t4;
  if ($[9] !== query.data?.scoProducts) {
    t4 = query.data?.scoProducts || [];
    $[9] = query.data?.scoProducts;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const products = t4;
  const T0 = SSRGate;
  const t5 = true;
  let t6;
  if ($[11] !== paywallOptionsValues.termId || $[12] !== products) {
    t6 = products && products.length > 0 && <TrackEvent action="productListViewed" onlyOnScreen={true} traits={{
      products,
      productTags: [paywallOptionsValues.termId]
    }} />;
    $[11] = paywallOptionsValues.termId;
    $[12] = products;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const T1 = Box;
  const t7 = "full";
  let t8;
  if ($[14] !== props.containerProps) {
    t8 = props.containerProps || {};
    $[14] = props.containerProps;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const T2 = VStack;
  const t9 = "center";
  const t10 = "xl";
  const t11 = "1em";
  let t12;
  if ($[16] !== getBreakpointValue || $[17] !== props.paddingY) {
    t12 = props.paddingY || getBreakpointValue({
      base: "1em",
      lg: "2em",
      xl: "4em"
    });
    $[16] = getBreakpointValue;
    $[17] = props.paddingY;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const t13 = "full";
  const t14 = props.stackProps;
  let t15;
  if ($[19] !== getBreakpointValue || $[20] !== props.hideTitle || $[21] !== props.title) {
    t15 = !props.hideTitle && <Box textAlign="center" width="full">{props.title || <Heading fontSize={getBreakpointValue(["1.5em", "2em", "2.25em", "2.5em"])}>Choose Your Membership</Heading>}</Box>;
    $[19] = getBreakpointValue;
    $[20] = props.hideTitle;
    $[21] = props.title;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== paywallOptions || $[24] !== paywallOptionsValues.termId || $[25] !== props.hideTermSelector) {
    t16 = !props.hideTermSelector && <Center paddingBottom="1em" paddingTop="0.5em" width="full"><PaywallTermSelector value={paywallOptionsValues.termId} terms={[{
        id: "month",
        title: "Monthly",
        discountBadge: null
      }, {
        id: "threeMonth",
        title: "Quarterly",
        discountBadge: "Save 16%"
      }, {
        id: "year",
        title: "Annually",
        discountBadge: "2 Months Free"
      }]} onChange={termId_1 => paywallOptions.termId.setValue(termId_1)} /></Center>;
    $[23] = paywallOptions;
    $[24] = paywallOptionsValues.termId;
    $[25] = props.hideTermSelector;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== query.error) {
    t17 = query.error && <Box bgColor="blackAlpha.500" borderRadius="sm" padding="1em">Error: {`${query.error}`}</Box>;
    $[27] = query.error;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  const T3 = Box;
  const t18 = "full";
  const T4 = Stack;
  const t19 = "stretch";
  let t20;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = ["column", "column", "row"];
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  const t21 = "1em";
  const t22 = "center";
  const t23 = "full";
  let t24;
  if ($[30] !== products || $[31] !== props.onProductSelect || $[32] !== props.productCardProps || $[33] !== props.productCardPropsByProductAndTermId || $[34] !== props.termIds || $[35] !== query.loading) {
    t24 = (productAndTerm, idx) => {
      const {
        productId: productId_1,
        termId: termId_2
      } = productAndTerm;
      const product = products.find(p => p.productId == productId_1 && p.effectiveTermId == termId_2);
      if (product) {
        return <PaywallProductCard key={idx} product={product} showTermInTitle={!!props.termIds} onSelect={props.onProductSelect} {...props.productCardProps || {}} {...props.productCardPropsByProductAndTermId?.[`${product.productId}-${product.effectiveTermId}`] || {}} />;
      } else {
        if (query.loading) {
          return <Center key={idx} bgColor="whiteAlpha.200" borderRadius="md" boxShadow="lg" flex={1} height="full" minHeight="600px" paddingY="3em" width="full"><Spinner /></Center>;
        } else {
          return null;
        }
      }
    };
    $[30] = products;
    $[31] = props.onProductSelect;
    $[32] = props.productCardProps;
    $[33] = props.productCardPropsByProductAndTermId;
    $[34] = props.termIds;
    $[35] = query.loading;
    $[36] = t24;
  } else {
    t24 = $[36];
  }
  const t25 = productAndTermIds.map(t24);
  let t26;
  if ($[37] !== T4 || $[38] !== t20 || $[39] !== t25) {
    t26 = <T4 align={t19} direction={t20} gap={t21} justify={t22} width={t23}>{t25}</T4>;
    $[37] = T4;
    $[38] = t20;
    $[39] = t25;
    $[40] = t26;
  } else {
    t26 = $[40];
  }
  let t27;
  if ($[41] !== T3 || $[42] !== t26) {
    t27 = <T3 width={t18}>{t26}</T3>;
    $[41] = T3;
    $[42] = t26;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  let t28;
  if ($[44] !== getBreakpointValue || $[45] !== props.hideFreeOption || $[46] !== props.hideOptionBar) {
    t28 = !props.hideOptionBar && <Stack align="center" bgColor="colorPalette.container" borderRadius="lg" boxShadow="lg" direction={getBreakpointValue(["column", "column", "row"])} gap="1em" justify="center" padding="1.5em" textAlign="center" width="full"><Heading fontSize="1.25em">Not sure which is best for you?</Heading>{!props.hideFreeOption && <ButtonLink href="/onboarding/welcome" variant="outline">Continue with Free Plan</ButtonLink>}<Button variant="outline" onClick={ev => {
        ev.preventDefault();
        setShowSalesModal(true);
      }}>Book a Free Consultation</Button></Stack>;
    $[44] = getBreakpointValue;
    $[45] = props.hideFreeOption;
    $[46] = props.hideOptionBar;
    $[47] = t28;
  } else {
    t28 = $[47];
  }
  let t29;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <Box />;
    $[48] = t29;
  } else {
    t29 = $[48];
  }
  let t30;
  if ($[49] !== appliedCouponCode || $[50] !== props.hideCouponCode) {
    t30 = !props.hideCouponCode && <CouponForm couponCode={appliedCouponCode} />;
    $[49] = appliedCouponCode;
    $[50] = props.hideCouponCode;
    $[51] = t30;
  } else {
    t30 = $[51];
  }
  let t31;
  if ($[52] !== T2 || $[53] !== props.stackProps || $[54] !== t12 || $[55] !== t15 || $[56] !== t16 || $[57] !== t17 || $[58] !== t27 || $[59] !== t28 || $[60] !== t30) {
    t31 = <T2 align={t9} borderRadius={t10} gap={t11} paddingY={t12} width={t13} {...t14}>{t15}{t16}{t17}{t27}{t28}{t29}{t30}</T2>;
    $[52] = T2;
    $[53] = props.stackProps;
    $[54] = t12;
    $[55] = t15;
    $[56] = t16;
    $[57] = t17;
    $[58] = t27;
    $[59] = t28;
    $[60] = t30;
    $[61] = t31;
  } else {
    t31 = $[61];
  }
  let t32;
  let t33;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = t34 => {
      const {
        open
      } = t34;
      return setShowSalesModal(open);
    };
    t33 = <Dialog.Backdrop />;
    $[62] = t32;
    $[63] = t33;
  } else {
    t32 = $[62];
    t33 = $[63];
  }
  let t34;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <Dialog.CloseTrigger position="absolute" right={0} top={0} />;
    $[64] = t34;
  } else {
    t34 = $[64];
  }
  let t35;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <Dialog.Header><Dialog.Title>Book a Free Consultation</Dialog.Title></Dialog.Header>;
    $[65] = t35;
  } else {
    t35 = $[65];
  }
  let t36;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <chakra.iframe minHeight="660px" src="https://meetings.hubspot.com/joe-bonaccorso/fg-meeting?embed=true" width="100%" />;
    $[66] = t36;
  } else {
    t36 = $[66];
  }
  let t37;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <Dialog.Positioner><Dialog.Content bgColor="container" maxWidth="800px" width="full">{t34}{t35}<Dialog.Body>{t36}<Box paddingY="1em"><Button width="full" onClick={() => setShowSalesModal(false)}>Close</Button></Box></Dialog.Body></Dialog.Content></Dialog.Positioner>;
    $[67] = t37;
  } else {
    t37 = $[67];
  }
  let t38;
  if ($[68] !== showSalesModal) {
    t38 = <Dialog.Root open={showSalesModal} onOpenChange={t32}>{t33}{t37}</Dialog.Root>;
    $[68] = showSalesModal;
    $[69] = t38;
  } else {
    t38 = $[69];
  }
  let t39;
  if ($[70] !== T1 || $[71] !== t31 || $[72] !== t38 || $[73] !== t8) {
    t39 = <T1 width={t7} {...t8}>{t31}{t38}</T1>;
    $[70] = T1;
    $[71] = t31;
    $[72] = t38;
    $[73] = t8;
    $[74] = t39;
  } else {
    t39 = $[74];
  }
  let t40;
  if ($[75] !== T0 || $[76] !== t39 || $[77] !== t6) {
    t40 = <T0 disableSSR={t5}>{t6}{t39}</T0>;
    $[75] = T0;
    $[76] = t39;
    $[77] = t6;
    $[78] = t40;
  } else {
    t40 = $[78];
  }
  return t40;
};
function _temp(t0) {
  const [productId, termId] = t0;
  return {
    productId,
    termId
  };
}